<template>
  <div class="result" v-if="isActivationOver">
    <div class="you-made-it" v-if="didActivationSucceed">Račun je uspješno aktiviran.</div>
    <div class="error" v-else>
      Niste uspjeli aktivirati račun. Molimo pokušajte ponovo, ili nas kontaktirajte na
      <a href="mailto:days@dump.hr">e-mail</a>.
    </div>
    <a href="/" class="return-home">Povratak na početnu &#10230;</a>
  </div>
</template>

<script>
export default {
  name: 'Activate',
  data() {
    return {
      didActivationSucceed: false,
      isActivationOver: false,
    };
  },
  mounted() {
    this.$axios
      .post(`${this.$API_URL}/user/activate`, {
        code: this.$route.query.code,
      })
      .then(() => {
        this.didActivationSucceed = true;
        this.isActivationOver = true;
      })
      // eslint-disable-next-line
      .catch(error => {
        this.didActivationSucceed = false;
        this.isActivationOver = true;
      });
  },
};
</script>

<style scoped>
.return-home {
  text-decoration: none;
  color: #30cec1;
  font-size: 24px;
}

.you-made-it {
  color: #1d9b90;
}
</style>
